<template>
    <div class="vh-margin-small-top">
        <p class="vh-margin-remove vh-text-italic" v-if="chips.length">
            You have search / filter:
        </p>

        <div class="vh-inline vh-margin-small-top">
            <vh-badge
                v-for="(item, index) in chips"
                :key="index"
                :item="item"
                @reset="onClick(item.query)"/>
        </div>
    </div>
</template>

<script>

export default
{
    props:
    {
        queries:
        {
            type: Object,

            default: () => 
            {
                return {
                    'search': 
                    {
                        name: '',
                        type: 'search',
                        icon: 'fa-search',
                        query: 'search',
                        options: ''
                    },
                }
                
            },
        },

        onClick:
        {
            type: Function,

            default: () =>
            {
                const query = Object.assign({}, this.$route.query);
                delete query[name];

                this.$router.replace({ query });
            }
        }
    },

    data()
    {
        return {
            chips: [],
        };
    },

    created()
    {
        this.initializeChips();
    },

    methods:
    {
        initializeChips()
        {
            const routeQueries = this.$route.query;
            
            const chips = [];

            Object.keys(this.queries).forEach((key) =>
            {

                if (Object.prototype.hasOwnProperty.call(routeQueries, key))
                {
                    const chip = this.queries[key];

                    chip.value = chip.type=='search'
                        ? `${routeQueries[key]}`
                        : Object.keys(chip.options).length > 0
                            ? `${chip.name}: ${chip.options[routeQueries[key]]}`
                            : `${chip.name}: ${routeQueries[key]}`;
                    
                    chips.unshift(chip);
                }
            });

            this.chips = chips;
        },

        reset(name)
        {
            const query = Object.assign({}, this.$route.query);
            delete query[name];

            this.$router.replace({ query });
        },
    },
    
    watch:
    {
        $route()
        {
            this.initializeChips();
        },
    },
};
</script>
